import React from "react";
import { TCText } from "../../../components/tcText/TCText";
import { Colors } from "../../../utils/colors";
import { TeamWithScores } from "../../../apis/types";

type props = {
  team?: TeamWithScores;
  isCurrentUserTeam: boolean;
};

export const TeamPlayersAppInstalled: React.FC<props> = ({
  team,
  isCurrentUserTeam,
}) => {
  return (
    <div style={{ flex: 1 }}>
      <TCText
        value={`App Installed: ${team?.playerA.isAppInstalled ? "✔️" : "❌"}`}
        // numberOfLines={1}
        style={{
          fontSize: 10,
          fontWeight: isCurrentUserTeam ? 600 : 500,
          color: isCurrentUserTeam ? Colors.green : Colors.grey,
          //   overflow: "hidden",
          //   textOverflow: "ellipsis",
        }}
      />
      <TCText
        value={`App Installed: ${team?.playerB.isAppInstalled ? "✔️" : "❌"}`}
        style={{
          fontSize: 10,
          fontWeight: isCurrentUserTeam ? 600 : 500,
          color: isCurrentUserTeam ? Colors.green : Colors.grey,
          marginTop: -3,
        }}
      />
    </div>
  );
};
